import LoginModule from './LoginPage';

export default LoginModule;
